import React from "react";
import { NavLink, useLocation } from "react-router-dom";

export type AdminHeaderLink = {
  label: string;
  href: string;
  external: boolean;
  active: boolean;
};

function normalizePathname(pathname: string) {
  const rawPathname = String(pathname || "").toLowerCase();
  return rawPathname.length > 1 ? rawPathname.replace(/\/+$/, "") : rawPathname;
}

function getHeaderLinks(pathname: string): AdminHeaderLink[] {
  const normalizedPath = normalizePathname(pathname);
  const isHomepageActive =
    normalizedPath === "/" ||
    normalizedPath === "/site-content" ||
    normalizedPath === "/history" ||
    normalizedPath === "/storage" ||
    normalizedPath === "/config";
  const isXconcepActive = normalizedPath === "/xconcepai";

  return [
    { label: "XconcepAI", href: "https://adm.theengineer.co.kr/xconcepai", external: false, active: isXconcepActive },
    { label: "홈페이지", href: "https://adm.theengineer.co.kr/theengineer", external: false, active: isHomepageActive },
    { label: "Fajob", href: "https://admin.fa-job.com/", external: false, active: false },
  ];
}

type AdminTopHeaderProps = {
  pathnameOverride?: string;
};

export function AdminTopHeader({ pathnameOverride }: AdminTopHeaderProps) {
  const location = useLocation();
  const headerLinks = getHeaderLinks(pathnameOverride || location.pathname);
  const emptyCells = 6;

  return (
    <header className="cm-topbar">
      <div className="adm-header-fill">
        <div className="adm-header-cell adm-header-cell-title">
          <span className="adm-header-title-text">통합 관리자 페이지</span>
        </div>
        {headerLinks.map((link) => (
          <div className="adm-header-cell" key={link.label}>
            {!link.external && link.href.startsWith("/") ? (
              <NavLink className={`adm-header-btn ${link.active ? "active" : ""}`.trim()} to={link.href}>
                {link.label}
              </NavLink>
            ) : (
              <a
                className={`adm-header-btn ${link.active ? "active" : ""}`.trim()}
                href={link.href}
                rel={link.external ? "noopener noreferrer" : undefined}
                target={link.external ? "_blank" : undefined}
              >
                {link.label}
              </a>
            )}
          </div>
        ))}
        {Array.from({ length: emptyCells }).map((_, index) => (
          <div aria-hidden="true" className="adm-header-cell is-empty" key={`adm-header-empty-${index}`} />
        ))}
      </div>
    </header>
  );
}
